import { Dialog } from "@kobalte/core/dialog";
import { dispatchGlobalEvent } from "@storytell/events";
import { AnimateChildren } from "@storytell/ui/animation";
import { StButton } from "@storytell/ui/buttons";
import { TbCopy, TbUpload } from "solid-icons/tb";
import { createSignal } from "solid-js";

export const PromptBarPasteContentCTA = () => {
  const [open, setOpen] = createSignal(false);
  return (
    <>
      <StButton
        onClick={() => setOpen(true)}
        class="group/btn select-none rounded-full pl-2 pr-3 py-1 flex items-center gap-2 cursor-pointer bg-panel hover:bg-panel-hover border border-primary-border text-primary-text h-[2.375rem] transition-all"
      >
        <TbCopy class="group-hover/btn:scale-hover group-active/btn:scale-active transition-all size-4" />
        <span class="text-base">Paste Content</span>
      </StButton>
      <AnimateChildren
        show={open()}
        enter={{ opacity: [0, 1], y: [30, 0] }}
        exit={{ opacity: [1, 0], y: [0, 30] }}
        duration={150}
      >
        {(anim) => (
          <Dialog
            open={anim.isMounted()}
            onOpenChange={(val) => {
              setOpen(val);
            }}
          >
            <Dialog.Portal>
              <AnimateChildren
                show={anim.isVisible()}
                enter={{ opacity: [0, 1] }}
                exit={{ opacity: [1, 0] }}
                duration={150}
              >
                {(sAnim) => (
                  <Dialog.Overlay
                    ref={sAnim.ref}
                    class="fixed z-50 inset-0 bg-black/30 dark:bg-white/10 animate-fade-in-quick"
                  />
                )}
              </AnimateChildren>
              <div ref={anim.ref} class="fixed z-50 inset-0 flex justify-end">
                <Dialog.Content
                  as={"form"}
                  onSubmit={(e) => {
                    e.preventDefault();
                    const title = (document.getElementById("pasted-content-title") as HTMLInputElement).value;
                    const content = (document.getElementById("pasted-content-content") as HTMLTextAreaElement).value;
                    const file = new File([content], `${title}.txt`, { type: "text/plain" });

                    dispatchGlobalEvent("upload-files", {
                      files: [file],
                    });

                    setOpen(false);
                  }}
                  class="fixed p-4 flex flex-col gap-4 left-1/2 top-1/2 z-overlay w-full max-w-lg -translate-x-1/2 -translate-y-1/2 rounded-lg bg-panel"
                >
                  <h3 class="font-medium text-lg">Paste any content as text</h3>
                  <label class="flex flex-col gap-2">
                    <span>Title</span>
                    <input
                      required
                      type="text"
                      id="pasted-content-title"
                      class="rounded-md w-full px-2 py-1 border border-primary-border"
                    />
                  </label>
                  <label class="flex flex-col gap-2">
                    <span>Content</span>
                    <textarea
                      id="pasted-content-content"
                      class="rounded-md w-full px-2 py-1 border border-primary-border p-1"
                      rows="10"
                      required
                    />
                  </label>
                  <div class="flex justify-end">
                    <StButton type="submit" icon={TbUpload}>
                      Upload Content
                    </StButton>
                  </div>
                </Dialog.Content>
              </div>
            </Dialog.Portal>
          </Dialog>
        )}
      </AnimateChildren>
    </>
  );
};
